import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=5a039139&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=5a039139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a039139",
  null
  
)

export default component.exports